import * as z from "../../../framework";
import * as realTimeUpdates from "../util/realTimeUpdates";
import reportHelperView from "./reportHelper.view";

export function buildPrintReportPopUp(args) {
    if (!$.isArray(args)) {
        args = [args];
    }

    $.each(args, function (index, arg) {
        var popUp = z.controls.popUp({
            id: arg.id,
            title: arg.title,
            height: "auto",
            width: 600,
            buttons: [
                {
                    name: z.ll("Close"),
                    className: "left"
                },
                {
                    name: z.ll("Print"),
                    id: "PrintButton",
                    className: "right",
                    clickEvent: function (e) {
                        var validator = popUp.get("#DocContainer").data("kendoValidator");
                        if (validator.validate()) {
                            popUp.window.wrapper.mask();
                            var correlationGroupId = kendo.guid();
                            var printerFriendlyParameterName = "printerFriendly";
                            if (arg.capitalPrinterFriendlyParameterName) {
                                printerFriendlyParameterName = "PrinterFriendly";
                            }

                            const format = popUp.get("#PrintFormat").data("kendoComboBox").value();
                            const isChecked = popUp.get("#PrintPrinterFriendly").is(":checked");

                            z.ajax({
                                url: `${arg.url}&formatId=${format}&${printerFriendlyParameterName}=${isChecked}`,
                                type: arg.urlType,
                                correlationGroupId: correlationGroupId,
                                errorHandled: true
                            }).done(function (response) {
                                z.util.ping({
                                    guid: response.d.results,
                                    correlationGroupId: correlationGroupId,
                                    errorHandled: true,
                                    success: function (pingResponse) {
                                        var button = popUp.get("#ViewReport");
                                        button.tie("click", function (clickEvent: any) {
                                            z.ajax({
                                                url: `Attachment/ActivateAttachment?id=${pingResponse.d.results}`,
                                                type: "GET",
                                                correlationGroupId: correlationGroupId,
                                                errorHandled: true,
                                                async: false
                                            }).done(function (data) {
                                                window.open(z.util.buildMediaUrl(data.d.results));

                                                if (arg && arg.closeCallback && (typeof arg.closeCallback === "function")) {
                                                    arg.closeCallback();
                                                }
                                            }).fail(function () {
                                                clickEvent.preventDefault();

                                                z.controls.alert({
                                                    type: "danger",
                                                    header: z.ll("ReportFailed"),
                                                    message: z.ll("ReportFailedMessage")
                                                });
                                                popUp.window.wrapper.unmask();
                                            });
                                        });
                                        button.parent().removeClass("hidden");
                                        popUp.window.wrapper.unmask();
                                        popUp.get("#PrintButton").addClass("hidden");
                                        popUp.get("#PrintPrinterFriendly").disable();
                                        popUp.get("#PrintFormat").disable();
                                        arg.successCallback && arg.successCallback(pingResponse.d.results);
                                    },
                                    error: function () {
                                        z.controls.alert({
                                            type: "danger",
                                            header: z.ll("ReportFailed"),
                                            message: z.ll("ReportFailedMessage")
                                        });

                                        popUp.window.wrapper.unmask();
                                        arg.errorCallback && arg.errorCallback();
                                    }
                                });
                            }).fail(function () {
                                z.controls.alert({
                                    type: "danger",
                                    header: z.ll("ReportFailed"),
                                    message: z.ll("ReportFailedMessage")
                                });

                                popUp.window.wrapper.unmask();
                            }).always(function () {
                                z.util.loadDefaults();
                            });
                        }
                        e.preventDefault();
                    }
                },
                {
                    id: "ViewReport",
                    name: z.ll("ViewReport"),
                    className: "hidden"
                }
            ],
            close: arg.closeCallback
        });

        var layout = reportHelperView(arg.entityList[0]);
        layout.options.zScreen = popUp;
        layout.render(popUp.guts);

        var observable = z.observable({
            InspectionResult: true
        });

        z.util.addDefaults({
            entityList: arg.entityList || [],
            observable: observable
        });

        z.bind({
            container: `#${popUp.screenId}`,
            bind: ".bind-label",
            data: z.LocalizedLanguage
        });
        z.bind({
            container: `#${popUp.screenId}`,
            bind: ".bind-value",
            data: observable
        });

        realTimeUpdates.registerCodeDataSource(popUp.get("#PrintFormat"), "ReportFormat");

        popUp.get("#HTMLContainer").hide();
        popUp.get("#DocContainer").zValidator();
    });
}
